import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import { trendingTopics, discussionBoard } from "@/mocks/site";

export default function TrendingBoard() {
  return (
    <section aria-labelledby="trending-title" className="bg-background-100 px-4 py-12 md:px-6 md:py-16">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <div className="mb-6 flex items-end justify-between gap-3">
            <div>
              <p className="mb-2 flex items-center gap-2 text-xs font-medium tracking-[0.25em] text-primary-600">
                <i className="ri-fire-line" aria-hidden="true" />
                HOT TODAY
              </p>
              <h2 id="trending-title" className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                今日必吃
              </h2>
            </div>
            <Link
              to="/news"
              className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
            >
              完整热榜
            </Link>
          </div>

          <ol className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
            {trendingTopics.map((topic, index) => {
              const target = articles[index] ? `/article/${articles[index].id}` : "/news";
              return (
                <li key={topic.id}>
                  <Link
                    to={target}
                    className="group flex items-center gap-4 px-4 py-4 transition-colors hover:bg-primary-100/40 md:px-5"
                  >
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                        index < 3
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      {index + 1}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-600 md:text-base">
                        {topic.title}
                      </span>
                      <span className="mt-1 flex items-center gap-3 text-xs text-foreground-500">
                        <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-secondary-900">
                          {topic.tag}
                        </span>
                        <span className="flex items-center gap-1">
                          <i className="ri-fire-fill text-primary-400" aria-hidden="true" />
                          {topic.heat}
                        </span>
                      </span>
                    </span>
                    <i
                      className="ri-arrow-right-s-line text-lg text-foreground-300 transition-colors group-hover:text-primary-500"
                      aria-hidden="true"
                    />
                  </Link>
                </li>
              );
            })}
          </ol>
        </div>

        <aside aria-labelledby="discuss-title" className="lg:col-span-1">
          <div className="mb-6">
            <p className="mb-2 flex items-center gap-2 text-xs font-medium tracking-[0.25em] text-secondary-600">
              <i className="ri-chat-smile-2-line" aria-hidden="true" />
              DISCUSSION
            </p>
            <h2 id="discuss-title" className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              热议话题榜
            </h2>
          </div>

          <ul className="space-y-3">
            {discussionBoard.map((item) => (
              <li key={item.id}>
                <Link
                  to="/news"
                  className="block rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-secondary-300"
                >
                  <span className="text-xs text-secondary-700">{item.tag}</span>
                  <h3 className="mt-1.5 text-sm font-medium leading-snug text-foreground-900">
                    {item.title}
                  </h3>
                  <p className="mt-2 flex items-center gap-1.5 text-xs text-foreground-500">
                    <i className="ri-chat-3-line" aria-hidden="true" />
                    {item.replies} 条讨论
                  </p>
                </Link>
              </li>
            ))}
          </ul>
        </aside>
      </div>
    </section>
  );
}